import { AfterViewInit, Component, OnDestroy, ViewChild } from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { DxTreeViewComponent } from "devextreme-angular/ui/tree-view";
import 'jspdf-autotable';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import saveAs from 'file-saver';

import { NotificationService } from "../common/component/notification/notification.service";
import { ScreenService } from "../services/screen.service";
import { IndustyCodesService } from "./industry-codes.service";

@Component({
    selector: 'app-industry-codes',
    templateUrl: './industry-codes.component.html',
    styleUrls: ['./industry-codes.component.scss']
})

export class IndustyCodesComponent implements AfterViewInit, OnDestroy {
    @ViewChild(DxTreeViewComponent, { static: false }) treeView: DxTreeViewComponent;
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    mappedindustrycodes: any[] = [];
    gindustrycodes: any[];
    apindustrycodes: any[];
    isApIndustryCodesLoaded: boolean = false;
    isGlobalIndustryCodesLoaded: boolean = false;
    isLoadPanelVisible: boolean = false;
    readonly allowedPageSizes = [50, 100, 200];

    constructor(private screenService: ScreenService, private notificationService: NotificationService, private industyCodesService: IndustyCodesService) {
        this.screen = this.screen.bind(this);
        this.getAllGlobalIndustrySegment();
        this.getAllMajorSegmentAPIndustrySegment();
        this.GetAllIndustryCodesMapings();
    }
    ngOnDestroy(): void {

    }
    ngAfterViewInit(): void {
      this.resetFilters();
    }

    resetFilters() {
        this.dataGrid?.instance?.clearFilter();
        this.dataGrid?.instance?.clearSorting();
    }

    addRow() {
        this.dataGrid.instance.addRow();
    }

    onEditorPreparing(e) {
        if (e.parentType === 'dataRow') {
            e.editorOptions.showClearButton = true;
        }
    }

    setGlobalIndustrySegmentValue(rowData: any, value: any): void {
        (<any>this).defaultSetCellValue(rowData, value);
    }

    setmajorSegmentAPIndustrySegmentValue(rowData: any, value: any) {
        (<any>this).defaultSetCellValue(rowData, value);
    }

    exportExcel(e) {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Industry Codes.xlsx');
                });
        });
        e.cancel = true;
    }

    screen(width: any) {
        return this.screenService.screenSize;
    }

    getAllGlobalIndustrySegment() {
        this.isLoadPanelVisible = true;
        this.industyCodesService.getGlobalIndustrySegments().subscribe({
            next: gsiccodes => {
                this.isGlobalIndustryCodesLoaded = true;
                this.gindustrycodes = gsiccodes;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.notificationService.alert("error", "Error while fetching Global Industry Segment", error);
                this.isLoadPanelVisible = false;
            }
        });
    }

    getAllMajorSegmentAPIndustrySegment() {
        this.isLoadPanelVisible = true;
        this.industyCodesService.getAPIndustrySegmentMajorSegments().subscribe({
            next: apcodes => {
                this.isApIndustryCodesLoaded = true;
                this.apindustrycodes = apcodes;
                this.isLoadPanelVisible = false;
                this.resetFilters();
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Major Segment - AP Industry Segment codes", error);
            }
        });
    }

    GetAllIndustryCodesMapings() {
        this.isLoadPanelVisible = true;
        this.industyCodesService.getIndustryCodesMapings().subscribe({
            next: mappedCodes => {
                this.mappedindustrycodes = mappedCodes;
                this.isLoadPanelVisible = false;
                this.resetFilters();
                this.dataGrid?.instance?.clearFilter();
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching Industry Code Mapings", error);
            }
        });
    }

    addMappings(event) {
        this.isLoadPanelVisible = true;
        this.industyCodesService.mapIndustryCodes(event.data).subscribe({
            next: (x: any) => {
                this.mappedindustrycodes = x;
                this.isLoadPanelVisible = false;
                this.notificationService.alert('success', 'Industry Code Mapped successfully!', null);
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while mapping industry codes", error);
            }
        });
    }
}
